import React from 'react';
import styles from '../styles/popover.scss';
const Popover = ({ type, message, title }) => (React.createElement("div", { className: (() => {
        switch (type) {
            case 'warning':
                return styles.bottom_notification_warning;
            case 'danger':
                return styles.bottom_notification_danger;
            case 'info':
            default:
                return styles.bottom_notification_info;
        }
    })() },
    React.createElement("div", { className: styles.notification_text },
        React.createElement("span", { className: styles.notification_title }, title),
        React.createElement("span", null, message))));
export default Popover;
